import { Checkbox } from 'antd'
import { WrappedFieldProps } from 'redux-form';
import { CheckboxProps } from 'antd/lib/checkbox';
import FormItem from 'antd/lib/form/FormItem';
import * as React from 'react';

interface CheckboxFieldProps extends WrappedFieldProps {
    readonly checkboxProps?: CheckboxProps;
}

export default function renderTreeSelect(props: CheckboxFieldProps) {

    const { input, checkboxProps, ...rest } = props;
    return (
        <FormItem
            {...rest}
        >
            <Checkbox
                checked={input.value ? input.value : undefined}
                value={input.value ? input.value : undefined}
                onChange={input.onChange}
                {...checkboxProps}
            // {...rest}
            />
        </FormItem>
    );
}



// WEBPACK FOOTER //
// ./src/reduxFormAntd/CheckboxField.tsx